
import THAI_WORDS from './thai-words.js';

function matchLargestWord(sentence) {
  for (let span=sentence.length; span>0; span--) {
    if (sentence[span] !== undefined && !isStandalone(sentence[span])) {
      continue;
    }

    let wordSlice = sentence.slice(0, span);
    if (THAI_WORDS.includes(wordSlice)) {
      return wordSlice;
    }
  }
  return null;
}

export default function splitThaiWords(sentence) {
  let words = [];
  let sentenceSlice = sentence;

  while (sentenceSlice.length > 0) {
    var wordMatch = matchLargestWord(sentenceSlice);
    if (wordMatch === null) {
      wordMatch = sentenceSlice[0];
    }

    words.push(wordMatch);
    sentenceSlice = sentenceSlice.slice(wordMatch.length)
  }

  return words;
}

function isStandalone(char) {
  let charCode = char.charCodeAt(0);
  return (
    (charCode >= 3585 && charCode <= 3630) || 
    (charCode >= 3648 && charCode <= 3654)
  );
}
